import { HStack } from '@chakra-ui/react';

export default function VStackRow({ children, ...props }) {
  return <HStack {...props}>{children}</HStack>;
}
